export default __webpack_public_path__ + "static/media/ADIZ_01_mos_JTAN.fe6b45de.wav";